'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _urls = require('../../../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = require('react-intl');

var _components = require('../../../../components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Support = require('./Support.scss');

var _Support2 = _interopRequireDefault(_Support);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var year = new Date().getFullYear();

var Support = function (_Component) {
    (0, _inherits3.default)(Support, _Component);

    function Support() {
        (0, _classCallCheck3.default)(this, Support);
        return (0, _possibleConstructorReturn3.default)(this, (Support.__proto__ || (0, _getPrototypeOf2.default)(Support)).apply(this, arguments));
    }

    (0, _createClass3.default)(Support, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['userData']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                openHealthcheckModal = _props.openHealthcheckModal,
                userData = _props.userData;
            var email = userData.email,
                _userData$firstName = userData.firstName,
                firstName = _userData$firstName === undefined ? '' : _userData$firstName,
                _userData$lastName = userData.lastName,
                lastName = _userData$lastName === undefined ? '' : _userData$lastName;

            var name = (firstName + ' ' + lastName).trim();

            return (0, _jsx3.default)('div', {
                className: _Support2.default.support
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.container
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'company'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/about'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'about'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: 'https://careers.jobscore.com/careers/liveauctioneers',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'careers'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: baseUrl + '/news/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_central_news'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: 'https://liveauctioneers.desk.com/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'support_center'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: 'https://liveauctioneers.desk.com/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'contact_us'
            })))))), (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'winning'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/how-it-works'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'how_auctions_work'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAllUpcomingAuctionsUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_calendar'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctioneerDirectoryUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_house_directory'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/find-auctions-near-me'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctions_near_you'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctionResultsUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_result_search'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/mobile'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'mobile'
            })))))), (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'selling'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/features'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'why_sell'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/seller-testimonials'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'seller_testimonials'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: baseUrl + '/pages/sell/'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'become_a_seller'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/consignments'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'consign_an_item'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: classicBaseUrl + '/user/login.html?url=/auctioneers/',
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctioneer_sign_in'
            }))))))), (0, _jsx3.default)('div', {
                className: _Support2.default['container-using']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'using'
            }), ': \xA0', (0, _jsx3.default)('span', {
                className: _Support2.default['new-site']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'the_new_liveauctioneers_site'
            })), ' ', '\xA0', (0, _jsx3.default)(_components.Link, {
                to: classicBaseUrl,
                className: _Support2.default['classic-link'],
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'classic_site'
            }))), (0, _jsx3.default)('div', {
                className: _Support2.default['social-icons']
            }, void 0, (0, _jsx3.default)('a', {
                className: _Support2.default.email,
                alt: 'Email',
                href: (0, _urls.getDeskSupportEmail)(name, email),
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0'), (0, _jsx3.default)('a', {
                className: _Support2.default.twitter,
                alt: 'Twitter',
                href: 'https://twitter.com/liveauctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0'), (0, _jsx3.default)('a', {
                className: _Support2.default.facebook,
                alt: 'Facebook',
                href: 'https://www.facebook.com/LiveAuctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0'), (0, _jsx3.default)('a', {
                className: _Support2.default.pinterest,
                alt: 'Pinterest',
                href: 'https://www.pinterest.com/liveauctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0')), (0, _jsx3.default)('div', {
                className: _Support2.default['container-copyright']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.copyright
            }, void 0, (0, _jsx3.default)('span', {}, void 0, '\xA9'), ' ', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'copyright',
                values: { year: year }
            }), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getTermsAndConditionsUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'terms_and_conditions'
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getPrivacyUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'privacy_policy'
            })), (0, _jsx3.default)(_reactFontawesome2.default, {
                className: _Support2.default.health,
                icon: ['fas', 'tachometer-alt'],
                onClick: openHealthcheckModal
            })), (0, _jsx3.default)('div', {
                className: _Support2.default.sitemap
            }, void 0, (0, _jsx3.default)('span', {
                className: _Support2.default['bold-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'sitemap'
            }), ':'), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/browse/archive/page1',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'past_auctions'
            })), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/browse/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'upcoming_auctions'
            })), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/search_auctioneers.html',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctioneer_directory'
            })))));
        }
    }]);
    return Support;
}(_react.Component);

exports.default = Support;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/Support/Support.js
// module id = s0Az
// module chunks = 57